import {
  FILTER_OPTIONS,
  buildSingleDocumentIndex,
  searchWithWordDropFallback,
} from "../../utils/searchOptions";

export function haystackMatchesQuery(
  query: string,
  ...parts: (string | null | undefined)[]
): boolean {
  const q = query.trim();
  if (!q) return true;

  const text = parts.filter(Boolean).join(" ");
  if (!text) return false;

  const index = buildSingleDocumentIndex(text);
  return searchWithWordDropFallback(index, q, FILTER_OPTIONS).results.length > 0;
}
